import Phaser from "phaser";
import ScoreLabel from "./ScoreLabel";
var StartButton

export default class StartScene extends Phaser.Scene
{
    constructor()
    {
        super('start-scene')
    }

    init(data)
    {
        this.score = data.score
    }

    preload()
    {
        this.load.image('startBackground', 'images/Blue.png')
        this.load.image('judul', 'images/text judul.png')
        this.load.image('start', 'images/start_button_2.png')
    }

    create()
    {
        this.add.image(240, 320, 'startBackground').setScale(10)
        this.add.image(240, 200, 'judul').setScale(0.7)
        StartButton = this.add.image(250, 500, 'start').setScale(0.8).setInteractive()

        StartButton.on('pointerdown', () => {
            this.scene.start('game-level-1')},this)
    }
}